import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Container,
  Grid,
  Typography,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import {
  fetchConToken
 } from "../../../../helpers/fetch";

export const BuscadorUsuarioOspe = (props) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [textoBuscado, setTextoBuscado] = useState("");

  const cargando = open && options.length === 0;
  let typingTimer=null

  const handleInputChange = (e) => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setTextoBuscado(e.target.value);
    }, 500);
  };

  const handleSeleccionado = (usuario) => {
    if (usuario) {
        props.setUsuarioSel(usuario)
    }else{
        props.setUsuarioSel()
    }
  };

  useEffect(() => {
    let active = true;
    (async () => {
      let texto = textoBuscado.replace("/", "__");
      if (texto.length > 0) {
        const response = await fetchConToken(`RelEfectorOspe/traerUsuarioOspe/${texto}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (active && lista.length > 0) {
            setOptions(
              lista
            );
          }
        }
      }else{
        setOptions([]);
      }
    })();
    return () => {
      active = false;
    };
  }, [textoBuscado]);


  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(()=>{
    clearTimeout(typingTimer)
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Grid container spacing={3}>
        {props.fullWith ||
          <Grid item xs={3}>
            <Typography
              component="h1"
              variant="h5"
              style={{
                marginLeft: 25,
                marginTop: 20,
                align: "center",
                color: "#FAFAFA",
                justifyContent: "center",
              }}
            >
              Buscar
            </Typography>
          </Grid>
        }
        <Grid item xs={props.fullWith ? 12 : 9}>
          <Container
            
            style={{
              padding: 3,
              marginTop: 5,
              margin: 5,
            }}
          >
            <Autocomplete
              disabled={props.disabled}
              style={{
                padding: 6,
                backgroundColor: "#FAFAFA",
                borderRadius: "5px",
              }}
              loadingText="Buscando..."
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              onChange={(e, newValue) => {
                handleSeleccionado(newValue);
              }}
              getOptionSelected={(option, value) =>
                option.nroMedico === value.nroMedico
              }
              getOptionLabel={(option) =>
                `${option.userName}`
              }
              renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>{`${option.userName}`}</span>
                </div>
              )}
              options={options}
              loading={cargando}
              renderInput={(params) => (
                <TextField
                  onChange={handleInputChange}
                  style={{
                    padding: 3,
                  }}
                  {...params}
                  variant="outlined"
                  label="Nombre de Usuario"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {cargando ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Container>
        </Grid>
      </Grid>
    </>
  );
};